import { useMediaQuery } from '@react-hookz/web'

import { PORTAL_BREAKPOINTS } from 'Constants/constants'

import { useStore } from 'Portal/src/stores'

import { useTaggingEnabled } from './useTaggingEnabled'

/**
 * Single source of truth for the passive Tags column on the GraphQL lists.
 *
 * The column shows only while all of these hold: an active organisation is set,
 * which is the admin-mode check the details screens use; that organisation has
 * finished loading, because `fetchOrganisation` installs the new organisation
 * before its portalConfig arrives and the previous organisation's `enableTags`
 * is briefly still in the store; `portalConfig.enableTags` is on; and the
 * viewport is desktop, because Tags are a desktop-only column.
 *
 * Consumers must be `observer` components so store changes reach them.
 */
export const useShowGraphqlListTags = () => {
  const { organisationStore } = useStore()
  const isTaggingEnabled = useTaggingEnabled()
  const isDesktop = useMediaQuery(`(min-width: ${PORTAL_BREAKPOINTS.LG})`)

  return (
    !!organisationStore.organisation?.id &&
    !organisationStore.isLoadingOrganisation &&
    isTaggingEnabled &&
    !!isDesktop
  )
}
